// extracted by mini-css-extract-plugin
export default {"root":"v27t44ylhx","root_scroll":"Ek9j6_3093"};